import React from 'react'
import { useField } from 'formik'

const FormCheckbox = ({ handle, options, required }) => {
  const [{ value }, { error, touched }, { setValue }] = useField(handle)

  return (
    <div className="mb-8 space-y-4">
      {options.map(option => (
        <div key={option.value}>
          <button
            type="button"
            className="flex text-left"
            onClick={() =>
              setValue(
                value.includes(option.value)
                  ? value.filter(opt => opt !== option.value)
                  : [...value, option.value],
              )
            }
          >
            <div
              className={`flex-shrink-0 mr-2 w-5.5 h-5.5 rounded ${
                value.includes(option.value)
                  ? 'border-2 border-black'
                  : `border ${
                      error && touched ? 'border-red' : 'border-gray-5'
                    }`
              } flex items-center justify-center`}
            >
              {value.includes(option.value) && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="10"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1.5 4.96l3.692 3.89 7.308-7.7"
                  ></path>
                </svg>
              )}
            </div>
            <div
              className={`${
                error && touched ? 'text-red' : 'text-black'
              } u-p -mt-0.5 link-wrapper`}
              dangerouslySetInnerHTML={{ __html: option.label }}
            />
          </button>
        </div>
      ))}
    </div>
  )
}

export default FormCheckbox
